import Cookies from 'js-cookie';

export const Helpers = (() => {
	'use strict';

	let acceptedCookiePrompt,
		cookieBanner,
		alertBanner,
		alertBannerClose,
		alertBannerDismissed;

	function init() {
		acceptedCookiePrompt = Cookies.get('acceptedCookiePrompt');
		cookieBanner = document.querySelector('.cookie-banner');

		alertBannerDismissed = Cookies.get('alertBannerDismissed');
		alertBanner = document.getElementById('alert-banner');
		alertBannerClose = document.getElementById('alert-banner-close');

		if (alertBanner && !alertBannerDismissed){
			alertBanner.style.display = 'block';
			alertBannerClose.addEventListener('click', () => {
				alertBanner.style.display = 'none';
				Cookies.set('alertBannerDismissed', 1, { expires: 7 });
			});
		}

		links();
		mobile_menu();
		body_scroll();
		smooth_anchor_scroll();
		
		if ( (!acceptedCookiePrompt || acceptedCookiePrompt == 0)){
			disable_google_analytics();

			if(cookieBanner && acceptedCookiePrompt === undefined){
				init_cookie_banner();	
			}
		}
	}

	function links() {
		document.querySelectorAll('a').forEach((anchorTag) => {
			// External links
			if (
				anchorTag.href.indexOf(window.location.host) < 0 &&
				anchorTag.href.indexOf('mailto') < 0 &&
				anchorTag.href.indexOf('tel') < 0
			)
				anchorTag.setAttribute('target', '_blank');

			// Anchor links
			if (
				anchorTag.href.indexOf('#') === 0 &&
				!document.getElementById(anchorTag.href.replace('#', ''))
			)
				window.scrollTo({ top: 0, behavior: 'smooth' });
		});
	}

	function mobile_menu() {
		const mobileTrigger = document.querySelector('.site-header__mobile-trigger');

		if (!mobileTrigger) return;

		mobileTrigger.addEventListener('click', () => {
			mobileTrigger.classList.toggle('open');
			document.body.classList.toggle('mobile-nav-open');
		});
		
		document.addEventListener('click', function(event) {
			var isClickInsideElement = document.querySelector('.menu-container').contains(event.target) || document.querySelector('.site-header__mobile-trigger').contains(event.target);
		
			if (!isClickInsideElement && document.body.classList.contains('mobile-nav-open')) {
				document.body.classList.remove('mobile-nav-open');
			}
		});	
		
		document.addEventListener('keydown', function(event) {
			if (event.key === 'Escape' && document.body.classList.contains('mobile-nav-open')) {
				document.body.classList.remove('mobile-nav-open');
			}
		});
	}

	function body_scroll() {
		window.addEventListener(
			'scroll',
			() => {
				window.scrollY > 1
					? document.body.classList.add('scrolled')
					: document.body.classList.remove('scrolled');
			},
			1
		);
	}

	function init_cookie_banner() {
		cookieBanner.classList.remove('hidden');

		if (!cookieBanner) return;

		cookieBanner.querySelectorAll('button').forEach((btn) => {
			btn.addEventListener('click', (ev) => {
				ev.preventDefault();

				let acceptance = btn.classList.contains('accept') ? 1 : 0;
				Cookies.set('acceptedCookiePrompt', acceptance);
				cookieBanner.classList.add('hidden');
				enable_google_analytics();
			});
		});
	}

	function smooth_anchor_scroll() {
		document.querySelectorAll('a[href^="#"]').forEach((link) => {
			link.addEventListener('click', function (e) {
				let targetId = link.getAttribute('href').replace('#', '');
				let targetElement = document.getElementById(targetId);
				
				if (targetElement) {
					e.preventDefault();
					window.scrollTo({
						top: targetElement.offsetTop,
						behavior: 'smooth'
					});
				}
			});
		});
	}

	function disable_google_analytics(){
		var analyticsScripts = document.querySelectorAll('script[src^="https://www.googletagmanager.com/gtag/js"]');
        analyticsScripts.forEach(function(script) {
            script.setAttribute('disabled', 'disabled');
        });		
	}

	function enable_google_analytics(){
		var analyticsScripts = document.querySelectorAll('script[src^="https://www.googletagmanager.com/gtag/js"]');
        analyticsScripts.forEach(function(script) {
            script.removeAttribute('disabled');
        });		
	}

	return {
		init: init
	};
})();
